import tw, { styled } from 'twin.macro';

export const MoviesContainer = styled.div`
  ${tw`
    my-6
    mx-1
  `}
`;

export const MoviesTitle = styled.h2`
  ${tw`
      text-xl
      font-semibold
      uppercase
      mx-8
      mt-6
    `}
  color: #f5f5f5;
`;

export const MoviesControls = styled.div`
  ${tw`
    pointer-events-none
    absolute
    inset-y-0
    left-0
    right-0
    flex
    items-center
    justify-between
    px-4
  `}
`;

export const MoviesControlButton = styled.button`
  ${tw`
    pointer-events-auto
    text-white
    font-bold
    w-11
    h-11
    rounded-full
  `}
  background: rgba(0, 0, 0, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.18);
  cursor: pointer;
`;

export const MoviesRowWrapper = styled.div`
  ${tw`
    relative
  `}
  --row-pad: 1.5rem;
  --row-gap: 1.25rem;
  --landscape-count: 5;
  --portrait-count: 6;

  @media (min-width: 1600px) {
    --landscape-count: 6;
    --portrait-count: 7;
  }

  @media (min-width: 1920px) {
    --landscape-count: 7;
    --portrait-count: 8;
  }

  @media (max-width: 1180px) {
    --landscape-count: 4;
    --portrait-count: 6;
  }

  @media (max-width: 900px) {
    --landscape-count: 3;
    --portrait-count: 5;
  }

  @media (max-width: 600px) {
    --landscape-count: 2;
    --portrait-count: 3;
  }
`;

export const MoviesRow = styled.div`
  ${tw`
      flex
      flex-nowrap
      overflow-x-auto
      mt-0
      py-4
    `}
  padding-left: var(--row-pad);
  padding-right: var(--row-pad);
  gap: var(--row-gap);
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const MoviesPoster = styled.div`
  ${tw`
    cursor-pointer
  `}
  flex: 0 0 auto;
  width: ${(props) => (props.$variant === 'landscape'
    ? 'calc((100vw - (2 * var(--row-pad)) - ((var(--landscape-count) - 1) * var(--row-gap))) / var(--landscape-count))'
    : 'calc((100vw - (2 * var(--row-pad)) - ((var(--portrait-count) - 1) * var(--row-gap))) / var(--portrait-count))')};
  min-width: ${(props) => (props.$variant === 'landscape'
    ? 'calc((100vw - (2 * var(--row-pad)) - ((var(--landscape-count) - 1) * var(--row-gap))) / var(--landscape-count))'
    : 'calc((100vw - (2 * var(--row-pad)) - ((var(--portrait-count) - 1) * var(--row-gap))) / var(--portrait-count))')};
  height: auto;
  aspect-ratio: ${(props) => (props.$variant === 'landscape' ? '16 / 9' : '2 / 3')};
  border-radius: 0.75rem;
  overflow: hidden;
  transition: all 0.2s;
  &:hover {
    transform: scale(1.16);
  }
  img {
    ${tw`
      w-full
      h-full
      object-cover
    `}
    display: block;
  }
`;

export const MoviesVideo = styled.video`
  ${tw`
    w-full
    h-full
    object-cover
  `}
  display: block;
`;
